import { render, staticRenderFns } from "./GrowlManager.vue?vue&type=template&id=2230c465&scoped=true&"
import script from "./GrowlManager.vue?vue&type=script&lang=js&"
export * from "./GrowlManager.vue?vue&type=script&lang=js&"
import style0 from "./GrowlManager.vue?vue&type=style&index=0&id=2230c465&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2230c465",
  null
  
)

export default component.exports